import { Outlet } from "react-router-dom"
import Header from "../../common-components/Layout/header/Header"
import { Grid2 as Grid } from "@mui/material"

const MainLayout = () => {
  return (
    <>
      <Grid flex={.05} size={12} borderBottom={'1px solid'} borderColor={'primary.light'}>
        <Header />
      </Grid>
      <Grid flex={.95} overflow={'auto'} size={12}>
        <Outlet />
      </Grid>

    </>
  )
}
export default MainLayout